export const calculateLoadColor = (
  loadByWeight: number | undefined,
  loadByLDM: number | undefined,
  status: string,
): string => {
  const maxLoad = Math.max(loadByWeight || 0, loadByLDM || 0);
  let color = 'black';

  if (status !== 'planning') {
    if (maxLoad < 50) {
      color = 'red';
    } else if (maxLoad < 80) {
      color = '#ffa940';
    }
  }

  return color;
};
